$(document).on('turbolinks:load', function(){
  let candidate_status_filter = $('#candidate_status_filter');
  $('#js-candidate-status-tab a').on('click', function(){
    let status = $(this).data('status');
    candidate_status_filter.val(status);
    $('#candidate_filter_submit_button').trigger('click');
  });
});